import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomePage.vue'
import ProductsView from '../views/ProductsPage.vue'
import ModelConfView from '../views/ModelConfPage.vue'
import ModelInfoPage from '../views/ModelInfoPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/certificados/*',
    name: 'certificados',
    component: ProductsView,
    props: true
  },
  {
    path: '/certificado/modelo/*',
    name: 'modelo',
    component: ModelInfoPage,
    props: true
  },
  {
    path: '/certificado/*',
    name: 'certificado',
    component: ModelConfView,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
